export const TYPE = {
    SET_ITEMS: 'SET_TYPE_ITEMS',
    SET_LOADING: 'SET_TYPE_LOADING',
    SET_ERROR: 'SET_TYPE_ERROR',
};

export const DELAI = {
    SET_ITEMS: 'SET_DELAI_ITEMS',
    SET_LOADING: 'SET_DELAI_LOADING',
    SET_ERROR: 'SET_DELAI_ERROR',
};

export const EQUIPEMENT = {
    ADD_ITEMS: 'ADD_EQUIPEMENT_ITEMS',
    SET_ITEMS: 'SET_EQUIPEMENT_ITEMS',
    SET_LOADING: 'SET_EQUIPEMENT_LOADING',
    SET_EXPORT_LOADING: 'SET_EXPORT_EQUIPEMENTS_LOADING',
    SET_ERROR: 'SET_EQUIPEMENT_ERROR',
    SET_EQUIPEMENT_FILTER: 'SET_EQUIPEMENT_FILTER',
    SET_GROUPE_FILTER: 'SET_EQUIPEMENT_GROUPE_FILTER',
    SET_SS_GROUPE_FILTER: 'SET_EQUIPEMENT_SS_GROUPE_FILTER',
    SET_PAGE: 'SET_EQUIPEMENT_PAGE',
    SET_NUMBER_OF_PAGES: 'SET_EQUIPEMENT_NUMBER_OF_PAGES',
    SET_SCROLL: 'SET_EQUIPEMENT_SCROLL',

    SET_ETAT_ITEMS: 'SET_ETAT_ITEMS',
    SET_ETAT_LOADING: 'SET_EQUIPEMENT_ETAT_LOADING',
    SET_ETAT_ERROR: 'SET_EQUIPEMENT_ETAT_ERROR',

    SET_INTERVENTIONS: 'SET_EQUIPEMENT_INTERVENTIONS',
    SET_INTERVENTIONS_LOADING: 'SET_EQUIPEMENT_INTERVENTION_LOADING',
    SET_INTERVENTIONS_ERROR: 'SET_EQUIPEMENT_INTERVENTION_ERROR',

    SET_SORT: 'SET_EQUIPEMENT_SORT',
};

export const INTERVENTION = {
    SET_SITE: 'INTERVENTION_SET_SITE',
    SET_SITES: 'INTERVENTION_SET_SITES',
    SET_TYPE: 'INTERVENTION_SET_TYPE',
    SET_DELAI: 'INTERVENTION_SET_DELAI',
    SET_DATE_AUTRE: 'INTERVENTION_SET_DATE_AUTRE',
    SET_EQUIPEMENT: 'INTERVENTION_SET_EQUIPEMENT',
    SET_ETAT_EQUIPEMENT: 'INTERVENTION_SET_ETAT_EQUIPEMENT',
    SET_OBJET: 'INTERVENTION_SET_OBJET',
    SET_DESCRIPTIF: 'INTERVENTION_SET_DESCRIPTIF',
    SET_SUIVI: 'INTERVENTION_SET_SUIVI',
    SET_RECURRENTE: 'INTERVENTION_SET_RECURRENTE',
    SET_CONTACT_SUR_SITE: 'INTERVENTION_SET_CONTACT_SUR_SITE',
    SET_CONTACT: 'INTERVENTION_SET_CONTACT',
    RESET_CONTACT: 'INTERVENTION_RESET_CONTACT',
    ADD_CONTACT_SUR_SITE: 'INTERVENTION_ADD_CONTACT_SUR_SITE',
    RESET_CONTACT_SUR_SITE: 'INTERVENTION_RESET_CONTACT_SUR_SITE',
    ADD_CONTACT: 'INTERVENTION_ADD_CONTACT',
    REMOVE_CONTACT_SUR_SITE: 'INTERVENTION_REMOVE_CONTACT_SUR_SITE',
    REMOVE_CONTACT: 'INTERVENTION_REMOVE_CONTACT',
    RESET_INTERVENTION: 'INTERVENTION_RESET_INTERVENTION',
    SET_STEP: 'SET_STEP',
    RESET_TO_STEP: 'INTERVENTION_RESET_TO_STEP',
    ADD_FILE: 'INTERVENTION_ADD_FILE',
    REMOVE_FILE: 'INTERVENTION_REMOVE_FILE',
    SET_RESPONSE: 'INTERVENTION_SET_RESPONSE',
    RESET_FILE: 'INTERVENTION_RESET_FILE',

    SET_LOADING: 'INTERVENTION_SET_LOADING',
    SET_ERROR: 'INTERVENTION_SET_ERROR',
    SET_SUCCESS: 'INTERVENTION_SET_SUCCESS',

    CLEAR_ALL: 'INTERVENTION_CLEAR_ALL',
    SET_SOCIETE_ASTREINTE: 'SET_SOCIETE_ASTREINTE',
    ADD_SOCIETE_JOUR_FERIE: 'ADD_SOCIETE_JOUR_FERIE'
};
